import { render } from "./ButtonClose.vue?vue&type=template&id=51b17063&scoped=true"
import script from "./ButtonClose.vue?vue&type=script&lang=js"
export * from "./ButtonClose.vue?vue&type=script&lang=js"

import "./ButtonClose.vue?vue&type=style&index=0&id=51b17063&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51b17063"]])

export default __exports__